import React, { FC } from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import NotFound from 'modules/core/components/NotFound'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import { useFixFlowProvider } from 'modules/contracts/components/FixFlow/FixFlowProvider'
import ContractDates from 'modules/contracts/components/FlowPage/Steps/Dates/ContractDates'
import CustomFields from 'modules/contracts/components/FlowPage/Steps/LegalAndExtras/CustomFields'
import RoleLevel from 'modules/contracts/components/FlowPage/Steps/RoleLevelSalary/RoleLevel'
import Salary from 'modules/contracts/components/FlowPage/Steps/RoleLevelSalary/Salary'
import { WorkHours } from 'modules/contracts/components/FlowPage/Steps/WorkHours'
import { useContractFlow } from 'modules/contracts/lib/contractFlowContext'
import { DataCollectionCategories } from 'modules/processes/domain'

interface Props {
  legalEntity: LegalEntity | null
  category: DataCollectionCategories
}

const Loading = () => {
  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center">
      <Spinner />
    </Box>
  )
}

const ContractData: FC<Props> = ({ legalEntity, category }) => {
  const { canEdit, loadingPermissions, loadingCustomFields, form } = useFixFlowProvider()
  const { contractVersion } = useContractFlow()

  if (loadingPermissions || loadingCustomFields) return <Loading />
  if (!Object.keys(form.data() || {}).length) return <Loading /> // when contract is still loading, the form is empty
  if (!canEdit) return <NotFound />

  switch (category) {
    case DataCollectionCategories.start_date:
      return <ContractDates form={form} contractVersion={contractVersion} />
    case DataCollectionCategories.role:
      return <RoleLevel withFormWrapper={false} withSeparator={false} form={form} />
    case DataCollectionCategories.salary:
      return <Salary withFormWrapper={false} form={form} canEditPayrollPolicy={false} /> // policy edition can not be done in task detail page
    case DataCollectionCategories.contract_hours:
      return (
        legalEntity && <WorkHours withFormWrapper={false} form={form} legalEntity={legalEntity} />
      )
    case DataCollectionCategories.contract_custom_fields:
      return <CustomFields withFormWrapper={false} form={form} />
    default:
      return null
  }
}

export default ContractData
